import React from "react";
// ANT DESIGN COMPONENTS
import { Select } from "antd";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";
// INTERFACES
import { ResponseContentTypesInterface } from "../../../interfaces/AdapterCdoOpc.interface";

export default function FormSelectOpcReadContentType({
	inputValue,
	inputOnChange,
	disabledInput,
}: {
	inputValue: ResponseContentTypesInterface;
	inputOnChange: (newValue: ResponseContentTypesInterface) => void;
	disabledInput: boolean;
}) {
	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */
	const { Option } = Select;
	const [t] = useTranslation("global");
	const OPTIONS: ResponseContentTypesInterface[] = [
		"read_item_response",
		"read_group_response",
		"get_names_response",
		"get_status_response",
		"get_server_list_response",
		"get_property_response",
	];

	// ************************************************ */
	// USE STATE VARIABLES **************************** */

	// ************************************************ */
	// REDUX SLICE VARIABLES ************************** */

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */

	// ************************************************ */
	// FUNCTIONS ************************************** */

	// ************************************************ */
	// USE EFFECT ************************************* */

	// ************************************************ */
	// COMPONENT ************************************** */
	return (
		<div className='col-md-12 mt-3'>
			<div className='generalStyles__flex'>
				<div className='generalStyles__inputFlexNameLarge'>
					<span className='generalStyles__inputFlexRequired'>*</span>
					<span>{t("general.contentType")}</span>
				</div>
				<div className='generalStyles__width100'>
					<Select
						className='generalStyles__width100'
						size='small'
						onChange={(e: any) => {
							inputOnChange(e);
						}}
						value={inputValue}
						disabled={disabledInput}
					>
						{OPTIONS.map((item: ResponseContentTypesInterface) => (
							<Option key={item} value={item}>
								{item.replace(/_/g, " ")}
							</Option>
						))}
					</Select>
				</div>
				<div className='generalStyles__infoTooltipIconBlank' />
			</div>
		</div>
	);
}
